export default __webpack_public_path__ + "static/media/wallet-connect-logo.a4166a89.svg";